<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" :class="[`${prefix}-icon`, `${prefix}-icon-videoDoc`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_7fcf42edf5__a"><rect width="20" height="20" rx="0"/></clipPath></defs><g clip-path="url(#svg_7fcf42edf5__a)"><path d="M15.2102,5.86838L17.6678,4.85975C18.2941,4.60222,19,5.025729999999999,19,5.65904L19,14.341C19.0001,14.9742,18.2942,15.3977,17.6678,15.1402L15.2102,14.1316L15.2102,15.2498C15.2102,16.2162,14.3622,16.9996,13.3159,17L2.89492,17C1.848386,17,1,16.2164,1,15.2498L1,4.75016C0.99999978317,3.783575,1.848386,3,2.89492,3L13.3159,3C14.3622,3.00036248,15.2102,3.783832,15.2102,4.75016L15.2102,5.86838ZM5.73695,7.31733L5.73695,12.68267C5.73738,12.84376,5.83358,12.99161,5.98739,13.0676C6.14119,13.1435,6.32775,13.1353,6.47304,13.0462L10.82988,10.36421C11.1113,10.19096,11.1113,9.80904,10.82988,9.63579L6.47304,6.95378C6.32775,6.864660000000001,6.14119,6.85646,5.98739,6.9324200000000005C5.83358,7.00839,5.73738,7.15624,5.73695,7.31733Z" :fill="useCurrentColor ? 'currentColor' : '#FF7D00'"/></g></svg>
</template>
<script>

export default {
  name: 'IconVideoDoc',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
